import React from 'react';
import Spinner from 'react-spinner';

import CountryProfileSectionList from './CountryProfileSecionList';

const CountryProfileBody = ({ data, isLoading, error }) => {
  if (isLoading) {
    return <Spinner />
  }

  if (error) {
    return <div className="error-message">Error loading report: {error}</div>;
  }

  if (!data || !Array.isArray(data) || data.length === 0) {
    return <p>No report information available.</p>;
  }

  return <CountryProfileSectionList list={data} />;
}

export default CountryProfileBody;



// WEBPACK FOOTER //
// ./src/components/CountryProfile/CountryProfileBody.js